module.exports = __webpack_public_path__ + "assets/Omega.e648fd009fd4456fde7d9a05708ec47f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Omega.png
// module id = 840
// module chunks = 0